import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Sell from "@/pages/Sell";
import Investors from "@/pages/Investors";
import Buyers from "@/pages/Buyers";
import Deals from "@/pages/Deals";
import DealDetail from "@/pages/DealDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Start from "@/pages/Start";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import VerifyEmail from "@/pages/VerifyEmail";
import NotFound from "@/pages/NotFound";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import LeadDetail from "@/pages/admin/LeadDetail";
import CaseStudyEditor from "@/pages/admin/CaseStudyEditor";
import SettingsPanel from "@/pages/admin/SettingsPanel";
import { captureTracking } from "@/lib/tracking";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { el.scrollIntoView({ behavior: "smooth", block: "start" }); return; }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  useEffect(() => { captureTracking(); }, []);
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
    <ScrollToTop />
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/sell" element={<Sell />} />
        <Route path="/investors" element={<Investors />} />
        <Route path="/buyers" element={<Buyers />} />
        <Route path="/deals" element={<Deals />} />
        <Route path="/deals/:slug" element={<DealDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/start" element={<Start />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/leads/:id" element={<LeadDetail />} />
      <Route path="/admin/case-studies" element={<CaseStudyEditor />} />
      <Route path="/admin/settings" element={<SettingsPanel />} />
    </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster theme="dark" position="top-right" />
      </BrowserRouter>
    </div>
  );
}
